import { RightsholderMaintenanceType } from '@Entities/schemas/rightsholder/rightsholder-maintenance-schema'
import { flattenObject } from '@App/helpers/flatten-object'
import { MemberSummary } from '@Entities/member/member-summary'

export const rightsholderModelToZodMapper = (rightsholderModel: MemberSummary): RightsholderMaintenanceType => ({
    ipId: rightsholderModel.ipId,
    name: rightsholderModel.name,
    ipiNumber: rightsholderModel.ipiNumber,
    hfaPublisherNumber: rightsholderModel.hfaPublisherNumber,
    isni: rightsholderModel.isni,
})

export const zodToRightsholderModelMapper = (rightsholderZodObj: RightsholderMaintenanceType): MemberSummary => {
    const { ...withoutPermissions } = rightsholderZodObj
    const rightsholderModel: MemberSummary = flattenObject(withoutPermissions)
    rightsholderModel.validationStatus = 'Done'
    return rightsholderModel
}
